
module.exports = {
   init: async function(parent,settings){
     this._parent=parent;
     this._settings=settings;
     this.grid_layout_end = 0;
   },
   pre_render: async function(DATA){
     this.data_length = DATA.length;
   },
   render: async function(LIST_POSITION,CURRENT_DATA,ITEM,ITEM_SETTINGS) {

      let _this = this._parent;
      _this.classList.add('list-view');
      let grid_size = 0;

      ITEM.classList.add('item');

      if(`layout-grid` in ITEM_SETTINGS)
      {
          grid_size = ITEM_SETTINGS[`layout-grid`];

          if(this.grid_layout_end==0)
          {
            this.grid_layout_end=grid_size
          }

          this.grid_layout_end--;

          if(this.grid_layout_end<1 || LIST_POSITION == this.data_length)
          {
            ITEM.classList.add('layout-grid-row-end');
            this.grid_layout_end=0;
          }

          switch(grid_size)
          {
              case "2":
                      ITEM.classList.add('layout-grid-2');
                      break;
              case "3":
                      ITEM.classList.add('layout-grid-3');
                      break;
              case "4":
                      ITEM.classList.add('layout-grid-4');
                      break;
              case "5":
                      ITEM.classList.add('layout-grid-5');
                      break;
              case "6":
                      ITEM.classList.add('layout-grid-6');
                      break;
              default:
                  break;
          }

      }

      switch(CURRENT_DATA.type)
      {
        case "collection":
              ITEM.onclick = function(){
                let component = document.createElement("dsb-reader");
                component.setDSBClient(_this.dsbClient);
                component.setAttribute(`service`, `post`);
                component.setAttribute('collection_id', CURRENT_DATA.id);
                component.innerHTML = `<maa-spinner></maa-spinner>`;
                window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
              }
              break;
        default:
              ITEM.onclick = function(){
                  let component = document.createElement("dsb-post");
                  component.setDSBClient(_this.dsbClient);
                  component._navigationHandler = function(direction){
                    return function__navigateItems(direction,i);
                  };
                  component.setAttribute(`service`, 'post');
                  component.setAttribute('post_id', CURRENT_DATA.id);
                  component.setAttribute(`settings`, JSON.stringify({'clean_body':'on','pulldown_refresh':'off'}));
                  component.innerHTML = `<maa-spinner></maa-spinner>`;
                  window.dispatchEvent(new CustomEvent('dsb-pwa-transient_modal', {detail: {content:component}}));
                  //window.location.hash = "/single/post/"+CURRENT_DATA.type+"/"+CURRENT_DATA.id;
                  return;
              };
              break;
      }


      if('author' in CURRENT_DATA)
      {
        if('type' in CURRENT_DATA.author)
        {
          switch(CURRENT_DATA.author.type)
          {
            case "advert":
                ITEM.classList.add('author-advert');
                break;
            default:
                break
          }
        }
      }

      if(`show-thumbnail` in ITEM_SETTINGS)
      {

          let item_image = document.createElement("span");
          item_image.classList.add('thumbnail');
          let attach_to_item = false;
          let image_size = "medium";
          let _post_image = this._settings.default_image;
          switch(ITEM_SETTINGS['show-thumbnail'])
          {
              case "right":
                  ITEM.classList.add(`layout-image-right`);
                  break;
              case "top":
                  ITEM.classList.add(`layout-image-top`);
                  image_size = "medium";
                  if(grid_size && grid_size<5)
                  {
                      image_size = "large";
                  }
                  break;
              case "left":
                  ITEM.classList.add(`layout-image-left`);
                  break;
              case "bottom":
                  ITEM.classList.add(`layout-image-bottom`);
                  image_size = "medium";
                  if(grid_size && grid_size<5)
                  {
                      image_size = "large";
                  }
                  break;
              case "background":
                  ITEM.classList.add(`layout-image-background`);
                  image_size = "large";
                  attach_to_item=true;
                  break;
              default:
                  break;

          }

          if('images' in CURRENT_DATA)
          {
            if(image_size in CURRENT_DATA.images)
            {
                _post_image = CURRENT_DATA.images[image_size];
            }
          }

          if(!attach_to_item)
          {
              item_image.setAttribute('data-img', _post_image);
              this._settings.imageObserver.observe(item_image);
          }
          else
          {
              ITEM.setAttribute('data-img', _post_image);
              this._settings.imageObserver.observe(ITEM);
          }
          ITEM.append(item_image);

      }

      let item_title = document.createElement("h2");
      if('title' in CURRENT_DATA)
      {
        item_title.innerHTML = CURRENT_DATA.title;
        ITEM.append(item_title);
      }
      else
      {
        console.error('Unknown title');
      }


      if(`show-excerpt` in ITEM_SETTINGS && (ITEM_SETTINGS[`show-excerpt`] == "true"))
      {
          if('excerpt' in CURRENT_DATA)
          {
              let item_excerpt = document.createElement("p");
              item_excerpt.innerHTML = CURRENT_DATA.excerpt;
              ITEM.append(item_excerpt);
          }
      }

      if('taxonomies' in CURRENT_DATA)
      {
        if('category' in CURRENT_DATA.taxonomies)
        {
          if(`show_all-categories` in ITEM_SETTINGS)
          {
              if('list' in CURRENT_DATA.taxonomies.category)
              {
                  let item_metadata = document.createElement("ul");
                  for(let ii = 0; ii < CURRENT_DATA.taxonomies.category.list.length; ii++)
                  {
                      let item_metadata_li = document.createElement("li");
                      item_metadata_li.innerHTML = await _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `primary_cat_slug`, CURRENT_DATA.taxonomies.category.list[ii] ] );
                      item_metadata.append(item_metadata_li);
                  }
                  ITEM.append(item_metadata);
              }
          }
          else
          {
              if('primary_id' in CURRENT_DATA.taxonomies.category)
              {
                  let item_metadata = document.createElement("ul");
                  let item_metadata_li = document.createElement("li");
                  let this_tax = await _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, CURRENT_DATA.taxonomies.category.primary_id ]);
                  if(typeof this_tax === 'object' && `root_parent` in this_tax)
                  {
                    this_tax = _this.dsbClient.content.applyFilter(`formatData_lookup`, [ `all_cat_obj`, this_tax.root_parent ]);
                  }
                  item_metadata_li.innerHTML = this_tax.name;
                  item_metadata.append(item_metadata_li);
                  ITEM.append(item_metadata);
                  if(ITEM.classList.contains(`layout-image-background`))
                  {
                    item_metadata_li.classList.add(this_tax.slug+'-category-bg-color');
                    item_metadata_li.style.padding="10px";
                    item_metadata_li.style.lineHeight="5px";
                  }
                  else
                  {
                    item_metadata_li.classList.add(this_tax.slug+'-category-font-col');
                  }

              }
          }
        }
      }
   }
}
